// A dashboard row: a pull request with what the dashboard knows of its
// attention and reviews.
import type { DashPr } from '../../api/queries';
import type { AttentionMember } from '../../engine/types';
import type { AttentionGap } from '../../logic/attentionGap';
import type { ReviewSummary } from '../../logic/reviewSummary';
import type { KnownAttention } from './attention';

export interface DashRow {
  pr: DashPr;
  /** Null until the attention inputs for this row have loaded, or when they failed to. */
  attention: AttentionMember[] | null;
  /** Why this row's attention could not be worked out (its attention is unknown). */
  attentionError: AttentionGap | null;
  /** Its reviewers and unresolved threads, from the attention inputs; null until those load or when they failed to. */
  review: ReviewSummary | null;
  /** In no section: a member of a native stack read by ID to show with it (`DashboardStore.pool`). */
  outside?: true;
}

/** `pr` as a row, with what `known` holds of it. */
export function rowOf(pr: DashPr, known: KnownAttention): DashRow {
  return {
    pr,
    attention: known.attention.get(pr.id) ?? null,
    attentionError: known.errors.get(pr.id) ?? null,
    review: known.reviews.get(pr.id) ?? null,
  };
}
